import {
    cloneDeep,
    util,
    isCorrectVal,
    isDate,
    lg
} from 'utils';
import services from './services.js';
//组件
import viewPhoto from 'src/common/js/viewPhoto';

//import address from 'agent-address';
//import agentSignMaterielv from 'agent-sign-materiel';
export default {
    mixins: [services],
    data() {
        return {
            loading: false,
            dialogVisible: false,
            id: 0,
            title: '',
            form: {},
            baseInfo: {},
            contact: {},
            Companys: []
        };
    },
    computed: {
        sysSid: function () {
            return this.$store.state.sysSid;
        },
        sysSession: function () {
            return this.$store.state.sysSession;
        }
    },
    watch: {

    },
    methods: {
        show(options) {
            this.dialogVisible = true
            this.title = options.title
            this.GetById(options.Id)


        },
        showImgView(img) {
            viewPhoto.show({
                showImgId: "xxx", //指定id显示图片
                thumbList: [{
                    src: img.Url,
                    id: "xxx"
                }]
            });
        },

        //关闭弹窗
        close() {

            this.dialogVisible = false;
        },

    }
};


// WEBPACK FOOTER //
// ./src/pages/CRMAgentManage/CRMFormatAgent/components/viewDialog/vm.js